<section class="functions-for-business-feature">
  <div class="box">
    <ng-container *ngFor="let item of ServiceList; let i = index">
      <div class="box-wrapper" [ngClass]="{ 'row-reverse': i % 2 === 0 }">
        <div class="box-wrapper__content">
          <h4 class="box-wrapper__content--title"
            ><span>{{ translate.currentLang === 'th' ? item.data.title.th : item.data.title.en }}</span></h4
          >
          <div class="box-wrapper__content--detail">{{
            translate.currentLang === 'th' ? item.data.description.th : item.data.description.en
          }}</div>
          <div class="box-wrapper__content--link">
            <div *ngIf="item.data.video.iv" class="link-vdo"
              ><i class="fab fa-youtube"></i
              ><a (click)="sharedService.openVideoTutorialModal(item.data.video.iv)" class="link-vdo__layout"
                ><span>{{ 'Function.Video' | translate }}</span></a
              ></div
            >
            <div *ngIf="item.data.document.iv" class="link-document"
              ><i class="far fa-file-alt"></i
              ><a [href]="item.data.document.iv" target="_blank" rel="noopener noreferrer" class="link-document__layout"
                ><span>{{ 'Function.Document' | translate }}</span></a
              ></div
            >
          </div>
        </div>
        <div class="box-wrapper__picture">
          <picture>
            <source [srcset]="item.data.imgWebp.iv" type="image/Webp" />
            <img [src]="item.data.img.iv" class="box-wrapper__picture--img" [alt]="item.data.alt.iv" loading="lazy" />
          </picture>
        </div>
      </div>
    </ng-container>
  </div>
</section>
